var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "completitud-externo" },
    [
      _c("header", { staticClass: "completitud-externo__header" }, [
        _c("img", {
          staticClass: "completitud-externo__logo",
          attrs: {
            src:
              "https://archivos.febos.io/publico/portales/escritoriodigital/ed-gris.png",
            alt: "Escritorio Digital"
          }
        }),
        _vm.ejecucion
          ? _c("div", { staticClass: "completitud-externo__info" }, [
              _c("h4", { staticClass: "completitud-externo__title" }, [
                _vm._v(
                  " Completitud de datos" +
                    _vm._s(
                      _vm.ejecucion.nombre ? ": " + _vm.ejecucion.nombre : ""
                    ) +
                    " "
                )
              ]),
              _c("p", { staticClass: "completitud-externo__subtitle" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.jwtData.name) +
                    " · " +
                    _vm._s(_vm.jwtData.email) +
                    " "
                )
              ])
            ])
          : _vm._e()
      ]),
      _c(
        "b-overlay",
        {
          staticClass: "completitud-externo__body",
          attrs: { show: _vm.loading, rounded: "sm" }
        },
        [
          _vm.error
            ? _c(
                "div",
                { staticClass: "completitud-externo__error" },
                [
                  _c("feather-icon", {
                    attrs: { icon: "AlertTriangleIcon", size: "20" }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.error))])
                ],
                1
              )
            : _vm.sent
            ? _c(
                "div",
                { staticClass: "completitud-externo__done" },
                [
                  _c("feather-icon", {
                    staticClass: "completitud-externo__done-icon",
                    attrs: { icon: "CheckCircleIcon", size: "40" }
                  }),
                  _c("h4", [_vm._v("¡Listo!")]),
                  _c("p", [
                    _vm._v(
                      "Los datos se enviaron correctamente y el documento continúa su flujo."
                    )
                  ])
                ],
                1
              )
            : _vm.ready
            ? _c(
                "div",
                { staticClass: "completitud-externo__viewer" },
                [
                  _c("PdfFormViewer", {
                    attrs: {
                      fields: _vm.fields,
                      s3url: _vm.documentUrl,
                      name: _vm.documentName,
                      active: true
                    },
                    model: {
                      value: _vm.values,
                      callback: function($$v) {
                        _vm.values = $$v
                      },
                      expression: "values"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm.ready && !_vm.error && !_vm.sent
        ? _c(
            "footer",
            { staticClass: "completitud-externo__footer" },
            [
              _c(
                "span",
                {
                  staticClass: "completitud-externo__hint",
                  class: { "is-error": _vm.invalidCount > 0 }
                },
                [
                  _vm.invalidCount > 0
                    ? [
                        _vm._v(
                          " Faltan " +
                            _vm._s(_vm.invalidCount) +
                            " campo(s) por completar o con error. "
                        )
                      ]
                    : [_vm._v(" Todo listo para enviar. ")]
                ],
                2
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "primary",
                    disabled: _vm.invalidCount > 0 || _vm.sending
                  },
                  on: { click: _vm.submit }
                },
                [
                  _vm.sending
                    ? _c("b-spinner", {
                        staticClass: "mr-1",
                        attrs: { small: "" }
                      })
                    : _vm._e(),
                  _vm._v(
                    " " + _vm._s(_vm.sending ? "Enviando..." : "Enviar") + " "
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }